module.exports = __webpack_public_path__ + "static/img/regimentRoom.7cbb41e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/linkBg/regimentRoom.jpg
// module id = 23DN
// module chunks = 1